/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface VacancyFieldsOneOf { 
    deleted?: boolean;
    deletedOn?: boolean;
    deletedBy?: boolean;
    createdOn?: boolean;
    modifiedOn?: boolean;
    createdBy?: boolean;
    modifiedBy?: boolean;
    id?: boolean;
    jobName?: boolean;
    city?: boolean;
    areaUnitBusiness?: boolean;
    employeeReplace?: boolean;
    ammount?: boolean;
    compensationScheme?: boolean;
    duration?: boolean;
    interviewProcess?: boolean;
    reason?: boolean;
    comments?: boolean;
    authorizationDate?: boolean;
    authorized?: boolean;
    justification?: boolean;
    candidate?: boolean;
    deliveryDate?: boolean;
    dateInitial?: boolean;
    code?: boolean;
    level?: boolean;
    dateCancellation?: boolean;
    dateDeclined?: boolean;
    dateSignature?: boolean;
    dateReactivated?: boolean;
    companyId?: boolean;
    requiredById?: boolean;
    authorizedById?: boolean;
    vacancyStatusId?: boolean;
    requisitionPersonalId?: boolean;
    jobPositionId?: boolean;
    requisitionTypeId?: boolean;
    contractTypeId?: boolean;
    substitutionTypeId?: boolean;
    placeTypeId?: boolean;
    authorizedSalaryId?: boolean;
    businessUnitId?: boolean;
}

